import { Button, Flex, Modal, Stack, Text } from "@flpstudio/design-system";

import { useModerateCommentMutation } from "@/hooks/use-comment-mutation";

export type Action = "HIDE" | "UNHIDE";

type Props = {
  commentId: string;
  groupId: string;
  action: Action;
  onClose: () => void;
};

export function ModerateConfirmationDialog({
  commentId,
  groupId,
  action,
  onClose,
}: Props) {
  const toHideAction = action === "HIDE";

  const { mutate, isPending } = useModerateCommentMutation({
    groupId,
  });

  return (
    <Modal
      opened={!!commentId}
      onClose={() => !isPending && onClose()}
      title={toHideAction ? "Hide comment?" : "Unhide comment?"}
    >
      <Stack>
        <Text className="text-[color:--mantine-color-gray-7]">
          {toHideAction
            ? "If hidden, this comment will be removed from public view."
            : "If unhidden, this comment will be shown to the public."}
        </Text>
        <Flex className="flex-col lg:flex-row-reverse">
          <Button
            color="red"
            variant="outline"
            loading={isPending}
            onClick={() => {
              mutate({ hide: toHideAction, commentId });
              onClose();
            }}
          >
            {toHideAction ? "Hide" : "Unhide"}
          </Button>
          <Button variant="outline" disabled={isPending} onClick={onClose}>
            Cancel
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}
